import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Updaters, Util } from '@leverege/api-attributes'
import classnames from 'classnames'
import { ValueFactory } from '~/editors/values'
import style from './style.css'

export default class SimAttributeEditor extends React.Component {
  
  static propTypes = {
    attribute : PropTypes.object,
    onSetValue : PropTypes.func.isRequired,
    onSetUpdater : PropTypes.func.isRequired,
    onShowFullEditor : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onValueChange = this.onValueChange.bind( this )
    this.shouldRender = true
  }

  onValueChange( evt ) {
    const { attribute, simulated, onSetValue, onSetUpdater, cxt } = this.props
    const type = attribute.type
    if ( simulated ) {
      const updater = Updaters.FunctionUpdaterCreator.create()
      updater.function = `${evt.value}`
      if ( type === 'boolean' ) {
        updater.update = -1 // send only once
      } else if ( type === 'string' ) {
        updater.update = -1 // send only once
        updater.function = `"${evt.value}"`
      } else {
        updater.update = 10 * 60 * 1000 // 10m 
      }
      onSetUpdater( { updater, attribute } )
    } else {
      const ids = Util.getPathIds( attribute.path )
      const colls = Util.getPathCollections( attribute.path )
      const resPath = Util.getResolvedPath( attribute.path, cxt || {}, ids, colls )

      if ( evt.override ) {
        onSetValue( { attribute : null, value : evt.value, cxt } )
        return
      }
      onSetValue( { attribute : { ...attribute, path : resPath }, value : evt.value, path : attribute.path, cxt } )
    }
  }

  onShowAdvanced() {
    this.props.onShowFullEditor( this.props.attribute )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    if ( this.shouldRender ) {
      this.shouldRender = false
      return true;
    }
    return false;
  }

  render() {
    const { attribute, simulated, className, cxt, liveMsg, inputProps, value, device } = this.props

    const valueEditor = ValueFactory.createEditor( 
      attribute, 
      { 
        value, device, cxt, focus : true, onChange : this.onValueChange, ...inputProps 
      } 
    )
    return ( 
      <div className={classnames( style.attributeEditor, className )}>
        {valueEditor}
        { simulated ? 
          <Button bsStyle="link" onClick={() => this.onShowAdvanced()}>Advanced</Button> :
          ( liveMsg != null ? liveMsg :
            (
              <div className={style.liveMsg}>
                Value may be changed by the
                {' '}
                <strong>live</strong>
                {' '}
                device
              </div>
            ) 
          ) }
      </div>
    )
  }
}
